import VehicleDataPage from './vehicle-data.page';

export default VehicleDataPage;
